export enum CitationSourceType {
  Filing = "Filing",
  Transcript = "Transcript",
  News = "News",
  Estimates = "Estimates",
  UserDocument = "UserDocument",
  Internet = "Internet",
}
